module.exports = __webpack_public_path__ + "img/id-number-3.ab2fc2a0.svg";